<template>
  <progress
    :max="max"
    :value="value"
    class="progress-bar"
    :aria-valuemax="max"
    :aria-valuenow="value"
    :aria-label="ariaLabel"
    :aria-valuetext="content"
    :style="progressBarStyle"
  />
</template>

<script lang="ts">
export default {
  name: 'ProgressBar',
  props: {
    max: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '#229150',
    },
  },
  computed: {
    ariaLabel(): string {
      return `A progress bar from 0 to ${this.max}`;
    },
    progressBarStyle(): string {
      return {
        '--progress-color': this.color,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.progress-bar {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  display: block;
  background-color: theme('colors.grey.divider.subdued');
  width: 100%;
  height: 4px;
  &::-webkit-progress-bar {
    background-color: theme('colors.grey.divider.subdued');
  }
  &::-webkit-progress-value {
    border-radius: 0 2px 2px 0;
    background-color: var(--progress-color);
    transition: all 0.25s ease-in-out;
    -webkit-transition: all 0.25s ease-in-out;
  }
  &::-moz-progress-bar {
    border-radius: 0 2px 2px 0;
    background-color: var(--progress-color);
    transition: all 0.25s ease-in-out;
    -webkit-transition: all 0.25s ease-in-out;
  }
}
</style>
